export function getByKeyword(list, byKeyword) {
  const search = byKeyword.trim().toLowerCase()
  if (!search.length) return list
  return list.filter(item => item.name.toLowerCase().indexOf(search) > -1)
}

export function getByRating(list, byRating) {
  if (byRating<= 0) return list
  return list.filter(item => item.rating.value == byRating)
}

export function getByVorstieg(list, byVorstieg) {
  if (!byVorstieg) return list
  return list.filter(item => item.isLead == byVorstieg)
}

export function getByToprope(list, byToprope) {
  if (!byToprope) return list
  return list.filter(item => item.isToprope == byToprope)
}

export function getByNew(list, byNew) {
  if (!byNew) return list
  return list.filter(item => isRecent(item.dateCreated))
}

export function getByContest(list, byContest) {
  if (!byContest) return list
  return list.filter(item => item.remarks.includes('Wettbewerb'))
}
// IMPORTANT *** change color condition after filter buttons approval
export function getByGrade(list, byGrade, color) {
    if(color == '#00838f') return list
    return list.filter(item => item.gradeNo >= (byGrade[0] / 3).toFixed(1) && item.gradeNo <= (byGrade[1] / 3).toFixed(1))
}

function isRecent (item) {
  var today = new Date().getTime()
  var neuCal = ( today - item ) / 86400000
  if (neuCal < 30) {
    return true
  } else {
    return false
  }
}
